import { z } from 'zod'

// Проект — источник истины company-backend. Инвариант: company_id NOT NULL
// (проект не существует без компании). Схема повторяет wire-контракт huma v2
// ProjectView: все поля обязательны, «пустое» описание — пустая строка.
// Теги в view не приходят — отдельный API entities/tag.

export const ProjectSchema = z.object({
  id: z.string(),
  company_id: z.string(),
  name: z.string(),
  slug: z.string(),
  description: z.string(),
  archived: z.boolean(),
  position: z.number(),
  version: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
})
export type Project = z.infer<typeof ProjectSchema>

// huma-обёртки ответов: одиночный — {data}; список проектов — {data} без
// пагинации (wire ProjectListOutputBody), data nullable.
export const ProjectResponseSchema = z.object({ data: ProjectSchema })

export const ProjectListSchema = z.object({
  data: z.array(ProjectSchema).nullable(),
})

// Тело create/patch (wire ProjectCreateInputBody / ProjectUpdateInputBody):
// company_id обязателен на create; version обязателен на PATCH.
export interface ProjectInput {
  company_id?: string
  name?: string
  slug?: string
  description?: string
  version?: number
}
